import React, {useEffect} from 'react';
import MaterialTable, { MTableActions } from "material-table";
import { useTranslation } from 'react-i18next';
import { Button, CircularProgress, Fade, IconButton, Modal, TextField} from '@material-ui/core';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import { autorun } from 'mobx';
import { observer, useLocalStore } from 'mobx-react-lite';
import { Notification } from '../../core/Notification';
import { useStores } from '../../_stores';
import { usePatchNotesStyles } from './PatchNotesStyle';
import { Cancel, Close } from '@material-ui/icons';

type PatchNotesProps = {
    isOpen: boolean;
    close: () => void;
}

const PatchNotes = observer((props: PatchNotesProps) => {
    //const classes = TableStyles();
    const {componentStore, patchNotesStore} = useStores();
    const { isOpen, close } = props;

    const classes = usePatchNotesStyles();
    const {t} = useTranslation();
    const translate = (variable: string) => {
        return t('components.' + variable);
    };

    useEffect(() => {
        autorun(async () => {
            // await componentStore.getAddress();
            // await componentStore.loadServices();
        });
    }, []);


    return (
        <div>
            <Modal
                open={isOpen}
                onClose={close}
                className={classes.modal}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                >
                    <Fade in={isOpen}>
                        <div>
                        <IconButton 
                            style = {{float: 'right', color: 'white'}} 
                            onClick = { async () => close()}>
                            <Cancel/>
                        </IconButton>
                            
                            <TextField 
                                id="outlined-basic"
                                variant="outlined" 
                                multiline
                                InputProps={{ readOnly: true, }}
                                value = {patchNotesStore.textPatchNote}
                                className={classes.paper}
                            />
                        </div>
                    </Fade>
            </Modal>
            {<Notification
                isOpen={componentStore.isNotification}
                close={() => componentStore.isNotification = false}
                okClick={() => componentStore.isNotification = false}
                questionText={componentStore.message}
            />}
        </div>
    )
});

export default PatchNotes;